const OFFICE = 'OFFICE';
const DIRECT = 'DIRECT';
const HOME = 'HOME';
const LIBRARY = 'LIBRARY';
const SCHOOL = 'SCHOOL';
const ACTIVED = 'ACTIVED';

export const DeliveryMethods = {
    OFFICE,
    DIRECT,
    HOME,
    SCHOOL,
    ACTIVED,
};
